module.exports = __webpack_public_path__ + "img/ic_register.0b60e8ba.webp";